<div id="xml-process-status-wrapper">
  <div class="col-12 search-ft p-0 mt-3">
    <div class="row align-items-end justify-content-start">
      <div class="col-2">
        <div class="form-group mb-0">
          <div class="input-group">
            <label class="control-label col-12 p-0" name="lblXMLFrmDt">Start Date</label>
            <input class="form-control" placeholder="Select Start Date" name="dpXMLFrmDt" ngbDatepicker
              [(ngModel)]="dpXMLFrmDate" #d1="ngbDatepicker">
            <div class="input-group-append dtToggle">
              <button class="btn btn-outline-secondary calendar" type="button" (click)="d1.toggle()"></button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group mb-0">
          <div class="input-group">
            <label class="control-label col-12 p-0" name="lblXMLToDt">End Date</label>
            <input class="form-control" placeholder="Select End Date" name="dpXMLToDt" ngbDatepicker
              [(ngModel)]="dpXMLToDate" #d2="ngbDatepicker">
            <div class="input-group-append dtToggle">
              <button class="btn btn-outline-secondary calendar" type="button" (click)="d2.toggle()"></button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group mb-0">
          <label class="control-label col-12 p-0" name="lblXMLUnitNumber"></label>
          <input type="text" class="form-control" name="txtXMLUnitNumber" [(ngModel)]="txtUnitNumber"
            placeholder="Filter by Unit Number" (input)="onUnitNumberFilter()">
        </div>
      </div>
      <div class="col-auto">
        <div class="form-group mb-0">
          <button class="btn btn-primary mr-2" name="btnXMLSearch" (click)="getGridDataByFilterSearch()">Search</button>
          <button class="btn btn-outline-primary mr-2" name="btnXMLReset" (click)="onResetFilters()">Reset</button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-2 mb-1">
    <div id="gridActions">
      <label class="mr-2" name="lblXMLExport" (click)="exportExcel()"><span>
          <em class="fas fa-file-download"></em></span> Export</label>
    </div>
  </div>
  <div class="mt-1">
    <ag-grid-angular #agGridXmlProcessStatus [enableCellTextSelection]="true"
      class="ag-theme-material provision-layout"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>
